import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "password",
    "confirmation",
    "togglePassword",
    "toggleConfirmation",
    "errorMessage",
  ];

  static values = {
    errorMessages: Array,
  };

  connect() {
    this.form = this.element.closest("form");

    // validação ao digitar
    this.passwordTarget.addEventListener("input", () => this.validate());
    this.confirmationTarget.addEventListener("input", () => this.validate());

    // validação ao enviar
    this.form.addEventListener("submit", (e) => {
      if (!this.validate()) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    this.updateSubmitButtons(true);
  }

  // Mostrar / ocultar senha
  togglePassword() {
    this._toggleField(this.passwordTarget, this.togglePasswordTarget);
  }

  toggleConfirmation() {
    this._toggleField(this.confirmationTarget, this.toggleConfirmationTarget);
  }

  _toggleField(field, iconWrapper) {
    if (field.type === "password") {
      field.type = "text";
      iconWrapper.innerHTML = '<i class="fas fa-eye-slash"></i>';
    } else {
      field.type = "password";
      iconWrapper.innerHTML = '<i class="fas fa-eye"></i>';
    }
  }

  // Validação completa
  validate() {
    if (!this.passwordTarget.offsetParent) return true;

    const pass = this.passwordTarget.value;
    const conf = this.confirmationTarget.value;
    let valid = true;
    let message = "";

    const regex =
      /^(?=.{8,128}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).*$/;

    if (!regex.test(pass)) {
      this.passwordTarget.classList.add("is-invalid");
      this.togglePasswordTarget.style.right = "45px";
      valid = false;
      message = this.errorMessagesValue[0];
    } else {
      this.passwordTarget.classList.remove("is-invalid");
      this.togglePasswordTarget.style.right = "30px";
    }

    if (conf.length > 0 && pass !== conf) {
      this.confirmationTarget.classList.add("is-invalid");
      this.toggleConfirmationTarget.style.right = "45px";
      valid = false;
      message = this.errorMessagesValue[1];
    } else {
      this.confirmationTarget.classList.remove("is-invalid");
      this.toggleConfirmationTarget.style.right = "30px";
    }

    if (!valid) {
      this.errorMessageTarget.style.display = "flex";
      this.errorMessageTarget.textContent = message;
    } else {
      this.errorMessageTarget.style.display = "none";
      this.errorMessageTarget.textContent = "";
    }

    this.updateSubmitButtons(valid);

    return valid;
  }

  updateSubmitButtons(valid) {
    if (!this.form) return;

    this.form
      .querySelectorAll('button[type="submit"], input[type="submit"]')
      .forEach((button) => {
        button.disabled = !valid;
      });
  }
}
